import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { usePriorities } from "@/context/PrioritiesContext";

const STATUS_MAP = {
  open: { label: "Open", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  in_progress: { label: "In Progress", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  pending_user: { label: "Pending User", cls: "bg-purple-50 text-purple-700 border-purple-200" },
  pending_department: { label: "Pending Department Action", cls: "bg-orange-100 text-orange-800 border-orange-300" },
  resolved: { label: "Resolved", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  closed: { label: "Closed", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  cancelled: { label: "Cancelled", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

const PRIORITY_MAP = {
  low: { label: "Low", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  medium: { label: "Medium", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  high: { label: "High", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  critical: { label: "Critical", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

export function StatusBadge({ value }) {
  const m = STATUS_MAP[value] || { label: value, cls: "bg-slate-100 text-slate-700 border-slate-200" };
  return (
    <Badge
      variant="outline"
      data-testid={`status-badge-${value}`}
      className={cn("font-medium rounded-full px-2.5 py-0.5 text-xs", m.cls)}
    >
      {m.label}
    </Badge>
  );
}

export function PriorityBadge({ value }) {
  const { priorityMap, toneClass } = usePriorities();
  const meta = priorityMap[value];
  const label = meta?.name || PRIORITY_MAP[value]?.label || value;
  const cls = meta?.color
    ? toneClass(meta.color)
    : (PRIORITY_MAP[value]?.cls || "bg-slate-100 text-slate-700 border-slate-200");
  return (
    <Badge
      variant="outline"
      data-testid={`priority-badge-${value}`}
      className={cn("font-medium rounded-full px-2.5 py-0.5 text-xs", cls)}
    >
      {label}
    </Badge>
  );
}

export const STATUS_OPTIONS = Object.entries(STATUS_MAP).map(([v, m]) => ({ value: v, label: m.label }));
export const PRIORITY_OPTIONS = Object.entries(PRIORITY_MAP).map(([v, m]) => ({ value: v, label: m.label }));
